// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingInvoicePaymentApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AdproductsBillingPortalAccountContactsDto,
  AdproductsUserMetroidAlicornPaymentResultDto,
  MetroidAlicornActionResultDto,
  MetroidAlicornSetAutopayResponseDto,
  MultiGuestPaymentRequestDto,
  MultiPaymentRequestDto,
  RentalManagerUserMetroidAlicornGuestPaymentDto,
  RentalManagerUserZuoraPaymentMethodListDto,
  StartMetroidAlicornPaymentMethodSessionDto,
  UserZuoraAccountPaymentMethodListDto,
  UserZuoraAccountSettingsListDto,
} from '../..';

interface AddAccountContactParams {
  accountNumber: string;
  emailToAdd: string;
}
interface DeleteAccountContactParams {
  accountNumber: string;
  contactId: string;
  emailToRemove: string;
}
interface DeletePaymentMethodV2Params {
  accountNumber: string;
  paymentMethodId: string;
  version?: string;
}
interface GetAccountContactsParams {
  accountNumber: string;
}
interface GetPaymentMethodsForAccountParams {
  accountNumber: string;
}
interface GetStartGuestPaymentMethodSessionForAccountParams {
  accountNumber: string;
  guestPaySessionId: string;
}
interface GetStartPaymentMethodSessionForAccountParams {
  accountNumber: string;
}
interface ImportPaymentMethodsParams {
  accountNumber: string;
}
interface LogAttemptExceedLimitationParams {
  accountNumber: string;
}
interface MakeInvoicePaymentV2Params {
  amount?: number;
  invoiceNumber: string;
  partialPayment?: boolean;
  paymentMethodId: string;
  version?: string;
}
interface RemoveAutopayParams {
  accountNumber: string;
  version?: string;
}
interface SaveDefaultPaymentMethodaAndEnableAutopayParams {
  accountNumber: string;
  autopayEnabled: boolean;
  defaultPaymentMethodId: string;
  version?: string;
}
interface SetAutopayParams {
  accountNumber: string;
}
interface SyncNewPaymentMethodParams {
  accountNumber: string;
  paymentMethodId: string;
}

export const AdproductsUserBillingInvoicePaymentApiHandler_addAccountContact_Path =
  '/api/web/v1/users/billing/invoicePayment/addAccountContact';

/**
 * Add an account contact
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_addAccountContact = (
  getParams: AddAccountContactParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AddAccountContactParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_addAccountContact_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_deleteAccountContact_Path =
  '/api/web/v1/users/billing/invoicePayment/deleteAccountContact';

/**
 * Remove an account contact
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_deleteAccountContact = (
  getParams: DeleteAccountContactParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteAccountContactParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_deleteAccountContact_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_deletePaymentMethodV2_Path =
  '/api/web/v1/users/billing/invoicePayment/deletePaymentMethodV2';

/**
 * Delete a payment method given a payment method id
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_deletePaymentMethodV2 = (
  getParams: DeletePaymentMethodV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeletePaymentMethodV2Params, never, MetroidAlicornActionResultDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_deletePaymentMethodV2_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getAccountContacts_Path =
  '/api/web/v1/users/billing/invoicePayment/getAccountContacts';

/**
 * Get account contacts for account number
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getAccountContacts = (
  getParams: GetAccountContactsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetAccountContactsParams, never, AdproductsBillingPortalAccountContactsDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getAccountContacts_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getAccountPaymentSettingsForUserV2_Path =
  '/api/web/v1/users/billing/invoicePayment/getAccountPaymentSettingsForUserV2';

/**
 * Get users zuora account settings
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getAccountPaymentSettingsForUserV2 = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, UserZuoraAccountSettingsListDto>(
    {
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getAccountPaymentSettingsForUserV2_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForAccount_Path =
  '/api/web/v1/users/billing/invoicePayment/getPaymentMethodsForAccount';

/**
 * Get payment methods for logged-in user and account
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForAccount = (
  getParams: GetPaymentMethodsForAccountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPaymentMethodsForAccountParams, never, UserZuoraAccountPaymentMethodListDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForAccount_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForUser_Path =
  '/api/web/v1/users/billing/invoicePayment/getPaymentMethodsForUser';

/**
 * Get payment methods for logged-in user
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForUser = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserZuoraPaymentMethodListDto>(
    {
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getPaymentMethodsForUser_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getStartGuestPaymentMethodSessionForAccount_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/getStartGuestPaymentMethodSessionForAccount';

/**
 * Get start payment method session from Metroid Alicorn for account number + guest pay session ID
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getStartGuestPaymentMethodSessionForAccount = (
  getParams: GetStartGuestPaymentMethodSessionForAccountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetStartGuestPaymentMethodSessionForAccountParams,
    never,
    StartMetroidAlicornPaymentMethodSessionDto
  >(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getStartGuestPaymentMethodSessionForAccount_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_getStartPaymentMethodSessionForAccount_Path =
  '/api/web/v1/users/billing/invoicePayment/getStartPaymentMethodSessionForAccount';

/**
 * Get start payment method session from Metroid Alicorn for account number
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_getStartPaymentMethodSessionForAccount = (
  getParams: GetStartPaymentMethodSessionForAccountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetStartPaymentMethodSessionForAccountParams,
    never,
    StartMetroidAlicornPaymentMethodSessionDto
  >(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_getStartPaymentMethodSessionForAccount_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_importPaymentMethods_Path =
  '/api/web/v1/users/billing/invoicePayment/importPaymentMethods';

/**
 * Trigger a payment method import for a given account number
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_importPaymentMethods = (
  getParams: ImportPaymentMethodsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ImportPaymentMethodsParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_importPaymentMethods_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_logAttemptExceedLimitation_Path =
  '/api/web/v1/users/billing/invoicePayment/logAttemptExceedLimitation';

/**
 * Log attempts exceeded error
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_logAttemptExceedLimitation = (
  getParams: LogAttemptExceedLimitationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LogAttemptExceedLimitationParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_logAttemptExceedLimitation_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_makeInvoicePaymentV2_Path =
  '/api/web/v1/users/billing/invoicePayment/makeInvoicePaymentV2';

/**
 * Make an invoice payment for a given invoice number and payment method id
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_makeInvoicePaymentV2 = (
  getParams: MakeInvoicePaymentV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<MakeInvoicePaymentV2Params, never, AdproductsUserMetroidAlicornPaymentResultDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_makeInvoicePaymentV2_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentForGuestInvoices_Path =
  '/api/web/v1/users/guestBilling/guestInvoicePay/makeMultiPaymentForGuestInvoices';

/**
 * Make guest invoice payment for given guestPaymentSessionId and payment method id
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentForGuestInvoices = (
  postData: MultiGuestPaymentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MultiGuestPaymentRequestDto, RentalManagerUserMetroidAlicornGuestPaymentDto>(
    {
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentForGuestInvoices_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentV2_Path =
  '/api/web/v1/users/billing/invoicePayment/makeMultiPaymentV2';

/**
 * Make an multiple payments for multiple accounts
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentV2 = (
  postData: Record<string, MultiPaymentRequestDto>,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    Record<string, MultiPaymentRequestDto>,
    Array<AdproductsUserMetroidAlicornPaymentResultDto>
  >(
    {
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentV2_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_removeAutopay_Path =
  '/api/web/v1/users/billing/invoicePayment/removeAutopay';

/**
 * Remove autopay for a given account number
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_removeAutopay = (
  getParams: RemoveAutopayParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RemoveAutopayParams, never, MetroidAlicornSetAutopayResponseDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_removeAutopay_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_saveDefaultPaymentMethodaAndEnableAutopay_Path =
  '/api/web/v1/users/billing/invoicePayment/saveDefaultPaymentMethodaAndEnableAutopay';

/**
 * Save default payment method and set autopay
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_saveDefaultPaymentMethodaAndEnableAutopay = (
  getParams: SaveDefaultPaymentMethodaAndEnableAutopayParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SaveDefaultPaymentMethodaAndEnableAutopayParams, never, MetroidAlicornActionResultDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_saveDefaultPaymentMethodaAndEnableAutopay_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_setAutopay_Path =
  '/api/web/v1/users/billing/invoicePayment/setAutopay';

/**
 * Set autopay for a given account number and payment method id
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_setAutopay = (
  getParams: SetAutopayParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SetAutopayParams, never, MetroidAlicornSetAutopayResponseDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_setAutopay_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_syncNewPaymentMethod_Path =
  '/api/web/v1/users/billing/invoicePayment/syncNewPaymentMethod';

/**
 * Sync a new payment method for account
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_syncNewPaymentMethod = (
  getParams: SyncNewPaymentMethodParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SyncNewPaymentMethodParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_syncNewPaymentMethod_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoicePaymentApiHandler_userHasPaymentMethods_Path =
  '/api/web/v1/users/billing/invoicePayment/userHasPaymentMethods';

/**
 * Check if user has any recorded payment methods
 */
export const AdproductsUserBillingInvoicePaymentApiHandler_userHasPaymentMethods = (client = getClient()) => {
  return httpFrontEndRequest<never, never, boolean>(
    {
      endpoint: AdproductsUserBillingInvoicePaymentApiHandler_userHasPaymentMethods_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};
